export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-480-32b0a4cd6fa2b73981a66e608fdb5ea3.png";